import * as React from 'react';

// Components
import Form from '@shopee/form-with-hook';

// Constants
import { FORM_CONFIG } from './config';

// Types
import { FormProps } from '@shopee/form-with-hook';

type Props = Pick<FormProps, Exclude<keyof FormProps, 'fieldConfigs'>>;

function AuthPasswordForm({ children, ...otherProps }: Props) {
  return (
    <Form {...otherProps} fieldConfigs={FORM_CONFIG}>
      {children}
    </Form>
  );
}

export default AuthPasswordForm;
